// src/components/NavigationBar.jsx

import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/images/logo.png';
import { LogOut, User, Users, ClipboardList, ThumbsUp, MessageCircle } from 'lucide-react';
import { ROLES } from '../App';

const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);
  const location  = useLocation();
  const navigate  = useNavigate();
  const { isAuthenticated, logout, auth } = useAuth();

  // Collapse menu on route change
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Get user role from auth context
  const userRole = auth?.user?.role;

  return (
    <Navbar
      bg="white"
      variant="light"
      expand="lg"
      sticky="top"
      className="shadow-sm"
      expanded={expanded}
    >
      <Container>
        <LinkContainer to="">
          <Navbar.Brand>
            <img
              src={logo}
              width="160"
              height="auto"
              className="d-inline-block align-top"
              alt="RxRooster Logo"
            />
          </Navbar.Brand>
        </LinkContainer>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(e => !e)}
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            {isAuthenticated ? (
              <>
                {/* For ADMIN users, show a dashboard dropdown */}
                {userRole === ROLES.ADMIN && (
                  <NavDropdown 
                    title={
                      <span>
                        <ClipboardList size={16} className="me-1" />
                        Admin Dashboard
                      </span>
                    } 
                    id="admin-nav-dropdown"
                  >
                    <LinkContainer to="admin">
                      <NavDropdown.Item>Admin Overview</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer to="listings/review">
                      <NavDropdown.Item>Review Listings</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                )}
                
                {/* For CRNA users, show provider dashboard */}
                {(userRole === ROLES.CRNA || userRole === ROLES.ADMIN) && (
                  <LinkContainer to="profile">
                    <Nav.Link>
                      <User size={16} className="me-1" />
                      Provider Dashboard
                    </Nav.Link>
                  </LinkContainer>
                )}
                
                {/* For GROUP users, show group dashboard & swipe/matches */}
                {(userRole === ROLES.GROUP || userRole === ROLES.ADMIN) && (
                  <>
                    <LinkContainer to="group-intake">
                      <Nav.Link>
                        <Users size={16} className="me-1" />
                        Group Dashboard
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="group-provider-swipe">
                      <Nav.Link>
                        <ThumbsUp size={16} className="me-1" />
                        Find Providers
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="group-matches">
                      <Nav.Link>
                        <MessageCircle size={16} className="me-1" />
                        My Matches
                      </Nav.Link>
                    </LinkContainer>
                  </>
                )}

                {(userRole === ROLES.GROUP || userRole === ROLES.ADMIN) && (
                  <LinkContainer to="upgrade">
                    <Button variant="success" size="sm" className="ms-2">
                      Upgrade
                    </Button>
                  </LinkContainer>
                )}

                {/* Logout button for all authenticated users */}
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={handleLogout}
                  className="ms-2"
                >
                  <LogOut size={16} className="me-1" />
                  Logout
                </Button>
              </>
            ) : (
              <>
              <LinkContainer to="login">
                <Nav.Link>Log in</Nav.Link>
              </LinkContainer>
              <LinkContainer to="register">
                <Nav.Link>Register</Nav.Link>
              </LinkContainer>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
